<rwidget-enter-new-card-modal
    #enterNewCardModal
    (cardAdded)="handleCardNumberAdded($event)"></rwidget-enter-new-card-modal>
<rwidget-top-up-other-person-card-modal
    #topUpOtherPersonCardModal
    (cardAdded)="handleCardNumberAdded($event)"></rwidget-top-up-other-person-card-modal>

<div class="mb-4 mt-4 bg-white p-4 [box-shadow:0px_2px_6px_-1px_rgba(0,0,0,0.1),0px_0px_4px_-1px_rgba(0,0,0,0.06)]">
    <div class="flex items-center justify-between">
        <h5 class="text-xs font-bold uppercase tracking-wide text-ironside_grey dark:text-contrast-yellow">
            {{ 'CARD_TO_TOP_UP' | translate }}
        </h5>
        <!-- Will be added later -->
        <!-- <button class="text-xs font-bold text-primary" (click)="addNewCard()">Enter new card</button> -->
    </div>

    <from class="mt-2" [formGroup]="cardForm">
        <!-- Conditionally show input if no related cards are available -->
        <ng-container *ngIf="!(relatedCards$ | async)?.length; else cardDropdown">
            <div formControlNameSelector="cardNumber">
                <mat-form-field class="w-full" appearance="fill">
                    <mat-label>
                        {{ 'CARD_NUMBER' | translate }}
                    </mat-label>
                    <input
                        class="w-full rounded-lg border border-solid border-[#F2F2F2] bg-grey-white_smoke px-2 py-4"
                        [maxlength]="cardValidationLength"
                        (input)="onCardNumberInput($event)"
                        formControlName="cardNumber"
                        matInput
                        type="text"
                        inputmode="numeric"
                        placeholder="{{ 'ENTER_CARD_NUMBER' | translate }}" />
                    <mat-error *ngIf="cardForm.get('cardNumber').hasError('required')">
                        {{ 'CARD_NUMBER_REQUIRED' | translate }}
                    </mat-error>
                    <mat-error *ngIf="cardForm.get('cardNumber').hasError('pattern')">
                        {{ 'CARD_NUMBER_INVALID' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </ng-container>

        <!-- Dropdown for selecting cards -->
        <ng-template #cardDropdown>
            <mat-form-field class="w-full" appearance="fill">
                <mat-label>
                    {{ 'CARD_TO_TOP_UP' | translate }}
                </mat-label>
                <mat-select
                    #matSelect
                    [value]="selectedCard$ | async"
                    [panelClass]="'custom-select-panel dark:bg-contrast-black'"
                    (selectionChange)="onCardSelectionChange($event)">
                    <div class="dropdown-container">
                        <!-- Saved Cards Section -->
                        <div class="dropdown-section px-4 dark:bg-contrast-black">
                            <h4
                                class="py-3 text-xs font-bold uppercase tracking-wide text-ironside_grey dark:text-contrast-yellow">
                                {{ 'SAVED_CARDS' | translate }}
                            </h4>
                            <mat-option
                                class="border-t border-solid border-black border-opacity-10 py-4 dark:border-contrast-yellow dark:text-contrast-yellow"
                                *ngFor="let card of relatedCards$ | async"
                                [value]="card">
                                <mat-icon class="!w-5 dark:bg-contrast-yellow" svgIcon="company-travel-card"></mat-icon>
                                {{ card.name }}
                            </mat-option>
                        </div>

                        <!-- Other Options Section -->
                        <div class="dropdown-section mt-8 px-4 dark:bg-contrast-black">
                            <h4
                                class="py-3 text-xs font-bold uppercase tracking-wide text-ironside_grey dark:text-contrast-yellow">
                                {{ 'OTHER_OPTIONS' | translate }}
                            </h4>
                            <div class="flex flex-col">
                                <!-- HIDE THIS BUTTON FOR NOW AS IT'S DOING THE SAME THING AS OTHER PERSON CARD BUTTON -->
                                <!--    <button
                                    class="border-t border-solid border-black border-opacity-10 py-4 text-base font-bold leading-5 text-primary"
                                    [value]="null"
                                    [attr.aria-label]="'ADD_NEW_CARD' | translate"
                                    (click)="addNewCard()">
                                    {{ 'ADD_NEW_CARD' | translate }}
                                </button> -->
                                <button
                                    class="gl-light:text-secondary border-t border-solid border-black border-opacity-10 py-4 text-base font-bold leading-5 text-primary dark:border-contrast-yellow dark:text-contrast-yellow"
                                    [value]="null"
                                    [attr.aria-label]="'TOP_UP_OTHER_PERSON_CARD' | translate"
                                    (click)="topUpOtherCard()">
                                    {{ 'TOP_UP_OTHER_PERSON_CARD' | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </mat-select>
            </mat-form-field>
            <mat-error *ngIf="paymentData.ticketCreationError$ | async">
                {{ 'CARD_NUMBER_INVALID' | translate }}
            </mat-error>
        </ng-template>
    </from>
</div>
